import React, { Fragment, useState } from 'react';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Collapse from "@material-ui/core/Collapse";
import { Link }  from "react-router-dom";
import Logo from '../../images/logoj.png';
import './style.css';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/home',
    },
    {
        id: 2,
        title: 'About Us',
        link: '/about',
        submenu: [
            {
                id: 21,
                title: 'Why Choose Us',
                link: '/about#why-choose-us'
            },
            {
                id: 22,
                title: 'Certificates',
                link: '/about#certificates'
            },
        ]
    },
    {
        id: 3,
        title: 'Products',
        link: '#',
        submenu: [
            {
                id: 31,
                title: 'Hydrochloric Acid',
                link: '/products/hydrochloric-acid'
            },
            {
                id: 32,
                title: 'Activated Carbon',
                link: '/products/activated-carbon'
            },
            {
                id: 33,
                title: 'Hydrated Lime',
                link: '/products/hydrated-lime'
            },
            {
                id: 34,
                title: 'Quick Lime',
                link: '/products/quick-lime'
            },
            {
                id: 35,
                title: 'Dolomite',
                link: '/products/dolomite'
            },
            {
                id: 36,
                title: 'Di Methyl Sulphate',
                link: '/products/dimethyl-sulphate'
            },
            {
                id: 37,
                title: 'Sodium Aluminate',
                link: '/products/sodium-aluminate'
            },
        ]
    },
    {
        id: 4,
        title: 'Industries',
        link: '/industries',
    },
    {
        id: 5,
        title: 'Contact',
        link: '/contact',
    }
]


const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
        setMenuState(false);
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="mobile-menu-header">
                    <div className="mobile-logo">
                        <Link onClick={ClickHandler} to="/home">
                            <img src={Logo} alt="Jagruti Chemicals" />
                        </Link>
                    </div>
                    <div className="menu-close">
                        <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                    </div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem className={item.id === openId ? 'active' : null}  key={mn}>
                                {item.submenu ?
                                    <Fragment>
                                        <div className="menu-item-with-submenu">
                                            <Link onClick={ClickHandler} to={item.link} className="main-menu-link">{item.title}</Link>
                                            <span className="submenu-toggle" onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                                                <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                            </span>
                                        </div>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                <Fragment>
                                                    {item.submenu.map((submenu, i) => {
                                                        return (
                                                            <ListItem key={i}>
                                                                <Link onClick={ClickHandler}
                                                                    to={submenu.link}>{submenu.title}</Link>
                                                            </ListItem>
                                                        )
                                                    })}
                                                </Fragment>
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                    : <Link onClick={ClickHandler}
                                        to={item.link}>{item.title}</Link>
                                }
                            </ListItem>
                        )
                    })}
                </ul>

            </div>

            <div className="showmenu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;